import Model from 'scripts/poppet/model';

/**
 * poppet.ControlModel
 * A control model for creating control models.
 * @version 1.0.0
 */

const ControlModel = Model.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: {
		// isValidData is true if the model contains valid data (fetched from backend or injected from app)
		isValidData: false,
		modelError: null,
		
		// useBackendApi is true if the model shall be saved to backend database. This option will be
		// set to false by the mobile app for Bluetooth units.
		useBackendApi: true,
	},
 
	completeList : ['isValidData', ],
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	onError: function (model, response, options) {
		if(options && options.isSaving){
			let attributeNames = Object.getOwnPropertyNames(options.attrs);
			for(const attributeName of attributeNames){
				let errorName = attributeName + 'Error';
				this.revertAttribute(attributeName);
				this.set(errorName, response.responseJSON.message);
			}
			this.set('isValidData', true);
			
		} else{
			this.set('isValidData', true);
			this.set('modelError', response.responseJSON.message) //
		}
	},
	
	//Override function to check if we should fetch from backend
	fetch: function( options ) {
		if( this.get('useBackendApi')) {
			return Bb.Model.prototype.fetch.call( this, options );
		}

		//Fetch from native app
		let self = this;
		let success = function() { console.log('fetched from app'); };
		
		if( options && options.success ) {
			success = options.success
		}

		this.set('isValidData', false);

		this.listenTo(this, 'change', function( model ){
			if(self.isComplete()) {
				self.stopListening(self);
				success();
			}
		});

		this.trigger('fetch:from:app', this);
	},
	
	save: function( attrs, options ) {
		let self = this;
		if( this.get('useBackendApi')) {
			let success = function() { console.log('Saved model'); };
			
			let saveOptions = options || {};
			
			if( saveOptions && saveOptions.success ) {
				success = saveOptions.success
			}
			let fetchDependentModels = function(){
				let models = self._getDependentModels();
				for(let index in models){
					models[index].fetch();
				}
			};
			saveOptions.success = function(){
				fetchDependentModels();
				success()
			};
			
			return Bb.Model.prototype.save.call( self,attrs, saveOptions );
		} else {
			return Bb.Model.prototype.save.call( self, {}, options);
		}

	},

	receivedData: function( data ) {
		this.set('isValidData', true);
		if ( data !== undefined && data !== null ) {
			data.isValidData = true;
			data.id = this.get('id');
		}
	},
	
	hasValidData: function(){
		return this.get('isValidData');
	},

	revertModel: function() {
		this.refresh();
	},

	//Override to check if we should sync toward backend
	sync: function(method, model, options) {
		if( this.get('useBackendApi')) {
			return Bb.Model.prototype.sync.call( this, method, model, options );
		}
		
		//This model shall not sync with backend. Trigger success callback.
		// Native shall listen for 'sync' events on the collection
		options.success();
	},

	//Override Bb.Model method.
	toJSON: function() {
		if( this.get('useBackendApi')) {
			return this.toBackendJSON();
		}

		return Bb.Model.prototype.toJSON.call(this);
	},

	//Override this in child class
	toBackendJSON: function() {
		console.log('Implement toBackendJSON in your model');
		return Bb.Model.prototype.toJSON.call(this);
	},

	//Override this in child class
	getAttributes: function() {
		return '';
	},

	refresh: function( options ) {
		this.set('isValidData', false);
		this.fetch( options );
	},
	
	revertAttribute: function(attribute) {
		let prev = JSON.parse(JSON.stringify(this._previousAttributes));
		this.set(attribute, this._previousAttributes[attribute]);
		this._previousAttributes = prev;
	},
	
	// Override this in childClass
	_getDependentModels: function(){
		return [];
	},
	
	parseAttribute: function (attributeName, responseAttribute, options, newAttributes) {
		let errorName = attributeName + 'Error';
		if('error' === responseAttribute.status){
			if (options !== undefined && options.isSaving) {
				this.revertAttribute( attributeName );
			}
			newAttributes[errorName] = responseAttribute.value
		} else {
			newAttributes[attributeName] = responseAttribute.value;
			newAttributes[errorName] = null;
		}
	},


} );

export default ControlModel;
